import React from 'react'
import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'

export default class Link extends React.Component {
  static propTypes = {
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    children: PropTypes.node,
  }

  static defaultProps = {
    to: '',
    children: null,
  }

  isExternal = (path) => {
    const r = new RegExp('^(?:[a-z]+:)?(?://)|^mailto:', 'i')
    return r.test(path)
  }

  render() {
    const { children, to, ...props } = this.props
    if (typeof to === 'string' && this.isExternal(to)) {
      return (
        <a href={to} {...props}>
          {children}
        </a>
      )
    }

    return (
      <RouterLink to={to} {...props}>
        {children}
      </RouterLink>
    )
  }
}
